<!-- <app-layout title="Pago de Informes">
            
</app-layout> -->

<app-layout title="Pago de Informes">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" 
         [class.active]="activeTab === 'tab1'"
         (click)="changeTab('tab1')">Historial de Pagos</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" 
         [class.active]="activeTab === 'tab2'"
         (click)="changeTab('tab2')">Generar Nuevo Pago</a>
    </li>
  </ul>
  
  <div class="tab-content mt-3">
    <div class="tab-pane fade" [class.show]="activeTab === 'tab1'" [class.active]="activeTab === 'tab1'" id="tab1">
      <app-list-reports-payments></app-list-reports-payments>
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab2'" [class.active]="activeTab === 'tab2'" id="tab2">
      <app-generate-layout-payments></app-generate-layout-payments>
    </div>
  </div>
  </app-layout>